import React, { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"

function ScrollToTop() {
  const { pathname, state } = useLocation()
  const { preventScrollToTop } = state || {}

  useEffect(() => {
    if (!preventScrollToTop) {
      window.scrollTo(0, 0)
    }
  }, [pathname, preventScrollToTop])

  return <Outlet />
}

export default ScrollToTop
